// pages/FormViewerPage/sections/orderSummary/QuantityRow.tsx — Stepper jumlah
import React from 'react';
import { ms } from '../../../../locales/ms';

const btn = 'w-8 h-8 text-xl text-slate-600 dark:text-slate-300 flex items-center justify-center hover:text-slate-900 dark:hover:text-white';

export const QuantityRow: React.FC<{ quantity: number; setQuantity: (n: number) => void; form?: any }> = ({ quantity, setQuantity, form }) => (
    <div className="flex items-center justify-between text-sm">
        <span className="text-slate-500 dark:text-slate-300">{ms(form, m => m.qty, 'Jumlah')}</span>
        <div className="flex items-center gap-3">
            <button type="button" onClick={() => setQuantity(Math.max(1, quantity - 1))} className={btn}>−</button>
            <span className="font-medium w-6 text-center">{quantity}</span>
            <button type="button" onClick={() => setQuantity(quantity + 1)} className={btn}>+</button>
        </div>
    </div>
);
